import { yupResolver } from '@hookform/resolvers/yup'
import { addDays, addMinutes, getMinutes } from 'date-fns'
import React from 'react'
import { Controller, FieldError, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { array, object } from 'yup'

import { StyledBox, SearchButton, FormContainer, SearchButtonContainer, Tooltip } from './styled'
import { testFormRange } from '../../services/yup'
import RangePicker from '../RangePicker'

interface IForm {
  range: [string, string]
}

interface JumbotronBoxProps {
  onSubmit: (range: IForm) => void
  isLoading?: boolean
  isTooltipVisible?: boolean
  initialValues?: [string, string]
}

export const formatInitialDate = (date: Date) => {
  const minutes = getMinutes(date)

  if (minutes === 0) {
    return date
  }

  return addDays(addMinutes(date, 60 - minutes), 1)
}

const JumbotronBox: React.FC<JumbotronBoxProps> = ({
  onSubmit,
  isLoading,
  isTooltipVisible,
  initialValues,
}) => {
  const { t } = useTranslation('common')

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<IForm>({
    resolver: yupResolver(
      object({
        range: array().test(testFormRange(t)),
      }).required()
    ),
    defaultValues: {
      range: initialValues || [
        formatInitialDate(new Date()).toISOString(),
        addDays(formatInitialDate(new Date()), 1).toISOString(),
      ],
    },
  })

  return (
    <StyledBox padding="large">
      <FormContainer onSubmit={handleSubmit(onSubmit)}>
        <Controller
          control={control}
          name="range"
          render={({ field }) => (
            <RangePicker
              error={errors.range as unknown as FieldError}
              startLabel={t('pickup')}
              endLabel={t('return')}
              {...field}
            />
          )}
        />
        <SearchButtonContainer>
          <Tooltip isVisible={isTooltipVisible}>{t('no_cars')}</Tooltip>
          <SearchButton type="submit" isLoading={isLoading}>
            {t('search')}
          </SearchButton>
        </SearchButtonContainer>
      </FormContainer>
    </StyledBox>
  )
}

export default JumbotronBox
